<template>
  <div class="footer">
    <div class="footer-content">
      <div class="copyright">
        Copyright@2020 All Rights Reserved
        <span v-if="isShow">
          {{ manystore.manystore_name }} {{ manystore.company_name ? manystore.company_name : "礼品网" }}
          <a target="_blank" href="http://beian.miit.gov.cn/" v-if="manystore.case_number">{{ manystore.case_number }}</a>
        </span>

        <span v-if="isShowWa">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41022502000040">豫公网安备41022502000040号</a>
          <a target="#">增值电信业务经营许可证：豫B2-20220846</a>
        </span>
      </div>
      <div class="footer-bottom" v-if="manystore.contacts_mobile || manystore.contacts_name || manystore.address">
        <div class="footer-contact" v-if="manystore.address">地址：{{ manystore.address }}</div>
        <span class="footer-contact" v-if="manystore.contacts_name">联系人：{{ manystore.contacts_name }}</span>
        <span class="footer-contact" v-if="manystore.contacts_mobile">联系方式：{{ manystore.contacts_mobile }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footerBox",
  computed: {
    manystore() {
      return this.$store.getters.manystore;
    },
    isShow() {
      var show = true;
      var hosts = ["dfh.jianuojy.com"];
      for (let i = 0; i < hosts.length; i++) {
        var host = location.host;
        if (hosts[i] === host) {
          show = false;
        }
      }
      return show;
    },
    isShowWa() {
      this.isShow360();
      var show = false;
      if (document.location.host == "bl.daifabashi.com") {
        show = true;
      }
      return show;
    },
  },
  methods: {
    isShow360() {
      // document
      if (document.location.host == "df99.jiantushangwu.top") {
        this.add360Common();
      }
    },
    add360Common() {
      const script = document.createElement("script");
      script.type = "text/javascript";
      let html = "(function(b,a,e,h,f,c,g,s){b[h]=b[h]||function(){(b[h].c=b[h].c||[]).push(arguments)};b[h].s=!!c;g=a.getElementsByTagName(e)[0];s=a.createElement(e);";
      html += 's.src="//s.union.360.cn/"+f+".js";s.defer=!0;s.async=!0;g.parentNode.insertBefore(s,g)})(window,document,"script","_qha",492103,false);';
      script.innerHTML = html;
      document.body.appendChild(script);
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.footer {
  width: 100%;
  min-width: 1300px;
  height: 80px;
  /* background-color: #0f375a; 国庆节 */
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}

.footer-content {
  height: 100%;
  width: 1300px;
  margin: 0 auto;
  color: #ffffff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.footer-bottom {
  display: flex;
  align-items: center;
  /*justify-content: space-between;*/
  margin-top: 5px;
}

.copyright {
  font-size: 12px;
}

.footer-contact {
  font-size: 12px;
  margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/footerBox/index.vue